import * as ng from 'angular';

export const PropsFilter: ng.FilterFactory = ($filter: ng.IFilterService) => {
    return (items, props) => {
        let out = [];
        if (ng.isArray(items)) {
            items.forEach((item) => {
                let itemMatches = false;
                let text = props.toLowerCase();
                if (item.toString().toLowerCase().indexOf(text) === 0) {
                    itemMatches = true;
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // let the output be the input untouched
            out = items;
        }

        return out;
    };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/filters/props-filter.filter.ts